import { useQuery } from "@tanstack/react-query";
import { jobHealthService } from "../services/jobHealth.service";
import type { JobHealthDto } from "../services/jobHealth.types";

/**
 * Background job health.
 *
 * `retry: false` — a 403 here is the normal answer for anyone without
 * `audit:read`, and retrying it three times per mount would put a burst of
 * failing requests behind every page load for most of the staff.
 *
 * Refetched on window focus with a five-minute staleness: this is the banner's
 * source, and a stale "everything is fine" is the failure mode the whole
 * feature exists to remove.
 */
export function useJobHealth(enabled = true) {
  return useQuery<JobHealthDto[]>({
    queryKey: ["job-health"],
    queryFn: () => jobHealthService.list(),
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  });
}

/** The jobs that need a person, worst first. Empty means everything is fine. */
export function problemJobs(jobs: JobHealthDto[] | undefined): JobHealthDto[] {
  const rank: Record<string, number> = { FAILED: 0, NEVER_RUN: 1, STALE: 2, OK: 3 };
  return (jobs ?? [])
    .filter((j) => j.status !== "OK")
    .sort((a, b) => rank[a.status] - rank[b.status]);
}
